module.exports = __webpack_public_path__ + "img/AICM智能会员管理图片.767086ce.png";